import { useQuery } from '@tanstack/react-query';
import { getAdminFilterMetadata } from './api';
import type { AdminFilterResource } from './types';

export function useAdminFilterMetadata(resource: AdminFilterResource) {
  return useQuery({
    queryKey: ['admin-filter-metadata', resource],
    queryFn: () => getAdminFilterMetadata(resource),
    staleTime: 5 * 60 * 1000,
  });
}
